import { collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import { fetchOpenPositions } from "../../../rtk/slices/openPositionsSlice/openPositionsSlice";
import { updateOpenPosition } from "../../../rtk/slices/openPositionsSlice/updateOpenPositionSlice";
import { closeOrder } from "../../../rtk/slices/orderCloseSlice/orderCloseSlice";
import { apiKey } from "../../../utils/config";
import { db } from "../../../firebase";

// Function to handle editing start
export const handleEditStart = (position_id, field, currentPrice, setEditingField, setEditValue) => {
    setEditingField({ position_id, field });
    setEditValue(currentPrice);  // Set current price as the editable value
};

// Function to handle update SL
export const handleUpdateSL = async (position, position_id, newSL, setEditingField) => {
    try {
        const tradeRef = doc(db, "trades_collection", position.id); // position.id is Firestore doc ID

        await updateDoc(tradeRef, {
            sl: Number(newSL)
        });

        console.log(`SL updated to ${newSL} for position ID: ${position_id}`);
    } catch (error) {
        console.error("Failed to update SL:", error.message);
    } finally {
        setEditingField(null); // Exit edit mode
    }
};

// Function to handle update TP
export const handleUpdateTP = async (position, position_id, newTP, setEditingField) => {
    try {
        const tradeRef = doc(db, "trades_collection", position.id);

        await updateDoc(tradeRef, {
            tp: Number(newTP)
        });

        console.log(`TP updated to ${newTP} for position ID: ${position_id}`);
    } catch (error) {
        console.error("Failed to update TP:", error.message);
    } finally {
        setEditingField(null); // Exit edit mode
    }
};


// Function to handle cancel edit
export const handleCancelEdit = (setEditingField, setEditValue) => () => {
    setEditingField(null);
    setEditValue('');
};



export const calculateProfit = (type, size, entryPrice, exitPrice, pip) => {
    const profit = (type === 'BUY') ? (exitPrice - entryPrice) * size : (entryPrice - exitPrice) * size;
    console.log({ type, size, entryPrice, exitPrice, pip });

    return (profit * pip).toFixed(2);
};

export const calculateMargin = (volume, contractSize, leverage, price) => {
    return (volume * contractSize * price) / leverage;
};

export const calculateProfitMargin = (positions, symbols, setCalculatedProfits, setTotalProfit, setTotalMargin, dispatch, setTP, totalProfit) => {
    if (!Array.isArray(positions)) {
        // console.error("Error: positions is not an array", positions);
        return;
    }

    const newProfits = {};
    let profitSum = 0;
    let marginSum = 0;

    positions.forEach((position) => {
        const symbolData = symbols[position.symbol];
        let cryptoSymbols = [
            "BTCUSD.", "BTCUSD.ex1", "ETHUSD.ex1", "XRPUSD.", "XRPUSD.ex1"
        ];
        let currencySymbols = ["USDJPY.", "GBPUSD.", "GBPCAD.", "USDCHF.", "EURUSD.", "AUDUSD.", "GBPNZD.", "AUDJPY.", "EURCAD.", "EURGBP.", "CADJPY.", "EURJPY.", "GBPJPY.", "EURCHF.", "EURNOK.", "USDCNH.", "EURSEK.", "NZDUSD.", "USDNOK.", "USDSEK.", "EURAUD.", "EURNZD.", "CADCHF.", "GBPCHF.", "CHFJPY.", "USDCAD.", "GBPAUD.", "NZDCHF.", "NZDJPY.", "NZDCAD."];
        let cfdSymbols = ["USTEC.ex1"];
        let otherSymbols = ["XTI."];
        let metalsSymbols = ["XAUUSD.", "XAGUSD.", "GOLDFUT-FEB25."];
        if (symbolData) {
            const type = position.type?.toUpperCase(); // in frontend too
            const entryPrice = parseFloat(position.price);
            const exitPrice = type === 'BUY' ? symbolData.bid : symbolData.ask;
            let pipValue = 0;
            let marginRate = 0;
            let contractSize = 0;
            if (metalsSymbols.includes(position.symbol)) {
                pipValue = 100;
                marginRate = 2;
                contractSize = 100;
            } else if (currencySymbols.includes(position.symbol)) {
                pipValue = 1000;
                marginRate = 1;
                contractSize = 100000;
            } else if (cfdSymbols.includes(position.symbol)) {
                pipValue = 1;
                marginRate = 0.01;
                contractSize = 1;
            } else if (otherSymbols.includes(position.symbol)) {
                pipValue = 1000;
                marginRate = 1;
                contractSize = 1000;
            } else if (cryptoSymbols.includes(position.symbol)) {
                pipValue = 1;
                marginRate = 0.05;
                contractSize = 1;
            } else {
                pipValue = 100000;
                marginRate = 1;
                contractSize = 1;
            }
            // const pipValue = position.symbol === 'XAUUSD' || position.symbol === 'GOLD.DEC.2024' ? 100 : position.symbol === 'XAGUSD' ? 5000 : 100000;
            const volume = parseFloat(position.volume);
            const formattedProfit = (
                type === 'BUY'
                    ? (exitPrice - entryPrice)
                    : (entryPrice - exitPrice)
            ) * volume * pipValue;

            const profit = formattedProfit.toFixed(2);

            // const profit = ((exitPrice - entryPrice) * volume * pipValue).toFixed(2);
            const margin = ((volume * contractSize * marginRate * exitPrice) / 100).toFixed(2);
            // const margin = ((position.volume * pipValue * exitPrice) / 100).toFixed(2);

            newProfits[position.position_id] = profit;
            profitSum += parseFloat(profit);
            marginSum += parseFloat(margin);
        }
    });

    setCalculatedProfits(newProfits);
    setTotalProfit(profitSum);
    setTotalMargin(marginSum);
    dispatch(setTP(totalProfit));
};

// export const handleOrderClose = (position, dispatch, setToastMessage, setShowToast) => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     const accountNum = user ? user.account : null;

//     if (accountNum) {
//         dispatch(closeOrder({
//             account: accountNum,
//             symbol: position.symbol,
//             volume: position.volume,
//             price: position.price,
//             type: position.type.toUpperCase(),
//             tp: position.tp,
//             sl: position.sl,
//             comment: '',
//             position_id: position.position_id,
//         })).then((res) => {
//             if (res.meta.requestStatus === 'fulfilled') {
//                 setToastMessage(`Order ${position.position_id} closed successfully.`);
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         });
//     }
// };

export const handleTouchStart = (
    event, position, longPressTimeout, symbols, setCurrentPriceLp, setLongPressedPosition,
    setIsModalOpen, calculatedProfits, setCp
) => {
    event.preventDefault();
    longPressTimeout.current = setTimeout(() => {
        const cleanSymbol = position.symbol?.split('.')[0]?.split('ex')[0]; // same as backend
        const symbolData = symbols[cleanSymbol];
        const price = position.type === 'BUY' ? symbolData?.bid : symbolData?.ask;
        setCurrentPriceLp(price);
        setLongPressedPosition(position);
        setIsModalOpen(true);

        const profit = calculatedProfits?.[position.position_id] || 0;
        // console.log('profit',profit);

        setCp(profit)
    }, 100);
};

export const handleTouchEnd = (longPressTimeout) => {
    if (longPressTimeout.current) {
        clearTimeout(longPressTimeout.current);
    }
};


export const handleBulkOrderClose = (positions, account, dispatch, toggleBulkModal) => {
    if (!account || !Array.isArray(positions) || positions.length === 0) {
        return;
    }
    const closePromises = positions.map((position) => {
        const orderData = {
            account: account,
            symbol: position.symbol,
            volume: position.volume,
            price: position.price,
            type: position.type.toUpperCase(),
            tp: position.tp,
            sl: position.sl,
            comment: '',
            position_id: position.position_id,
        };

        return dispatch(closeOrder(orderData));
    });
    Promise.all(closePromises)
        .then((results) => {
            const allSuccess = results.every(
                (response) => response.meta.requestStatus === 'fulfilled'
            );

            if (allSuccess) {
                if (toggleBulkModal) toggleBulkModal();
            } else {
                alert('Some orders failed to close');
            }
        })
        .catch(() => {
            alert('An error occurred while closing orders');
        });
};

export const handleSellOrdersClose = (positions, account, dispatch, toggleBulkModal) => {
    if (!account || !Array.isArray(positions) || positions.length === 0) {
        return;
    }
    const sellPositions = positions.filter((position) => position.type.toUpperCase() === 'SELL');

    if (sellPositions.length === 0) {
        if (toggleBulkModal) toggleBulkModal();
        return;
    }

    const closePromises = sellPositions.map((position) => {
        const orderData = {
            account: account,
            symbol: position.symbol,
            volume: position.volume,
            price: position.price,
            type: position.type.toUpperCase(),
            tp: position.tp,
            sl: position.sl,
            comment: '',
            position_id: position.position_id,
        };

        return dispatch(closeOrder(orderData));
    });

    Promise.all(closePromises)
        .then(() => {
            if (toggleBulkModal) toggleBulkModal();
        })
        .catch(() => {
            console.error('Error occurred while closing SELL orders');
            if (toggleBulkModal) toggleBulkModal();
        });
};

export const handleLosingPositionsClose = (positions, account, calculatedProfits, dispatch, toggleBulkModal) => {
    if (!account || !Array.isArray(positions) || positions.length === 0) {
        return;
    }
    const losingPositions = positions.filter(
        (position) => calculatedProfits[position.position_id] < 0
    );

    if (losingPositions.length === 0) {
        if (toggleBulkModal) toggleBulkModal();
        return;
    }
    const closePromises = losingPositions.map((position) => {
        const orderData = {
            account: account,
            symbol: position.symbol,
            volume: position.volume,
            price: position.price,
            type: position.type.toUpperCase(),
            tp: position.tp,
            sl: position.sl,
            comment: '',
            position_id: position.position_id,
        };

        return dispatch(closeOrder(orderData));
    });
    Promise.all(closePromises)
        .then(() => {
            if (toggleBulkModal) toggleBulkModal();
        })
        .catch(() => {
            console.error('Error occurred while closing losing positions');
            if (toggleBulkModal) toggleBulkModal();
        });
};

export const handleCloseAllPressedSymbolOrders = (account, positions, longPressedPosition, dispatch, toggleBulkModal) => {
    if (!account || !Array.isArray(positions) || positions.length === 0 || !longPressedPosition) {
        return;
    }
    const symbolPositions = positions.filter(
        (position) => position.symbol === longPressedPosition?.symbol
    );

    if (symbolPositions.length === 0) {
        toggleBulkModal();
        return;
    }
    const closePromises = symbolPositions.map((position) => {
        const orderData = {
            account: account,
            symbol: position.symbol,
            volume: position.volume,
            price: position.price,
            type: position.type.toUpperCase(),
            tp: position.tp,
            sl: position.sl,
            comment: '',
            position_id: position.position_id,
        };

        return dispatch(closeOrder(orderData));
    });

    Promise.all(closePromises)
        .then(() => {
            if (toggleBulkModal) toggleBulkModal();
        })
        .catch(() => {
            console.error('Error occurred while closing symbol positions');
            if (toggleBulkModal) toggleBulkModal();
        });
};

export const handleCloseAllPressedSymbolSellOrders = (account, positions, longPressedPosition, dispatch, toggleBulkModal) => {
    if (!account || !Array.isArray(positions) || positions.length === 0 || !longPressedPosition) {
        return;
    }
    const sellSymbolPositions = positions.filter(
        (position) => position.symbol === longPressedPosition.symbol && position.type === 'SELL'
    );

    if (sellSymbolPositions.length === 0) {
        if (toggleBulkModal) toggleBulkModal();
        return;
    }
    const closePromises = sellSymbolPositions.map((position) => {
        const orderData = {
            account: account,
            symbol: position.symbol,
            volume: position.volume,
            price: position.price,
            type: position.type.toUpperCase(),
            tp: position.tp,
            sl: position.sl,
            comment: '',
            position_id: position.position_id,
        };

        return dispatch(closeOrder(orderData));
    });

    Promise.all(closePromises)
        .then(() => {
            if (toggleBulkModal) toggleBulkModal();
        })
        .catch((error) => {
            console.error('Error occurred while closing "SELL" positions for the symbol:', error);
            if (toggleBulkModal) toggleBulkModal();
        });
};
export const handleOrderClose = async (position, setToastMessage, setShowToast) => {

    console.log('🧨 Attempting to close position:', position);
    console.log('🆔 Firestore doc ID:', position.id);


    try {
        if (!position?.id) throw new Error("Missing document ID");

        const user = JSON.parse(localStorage.getItem("user"));
        const currentAccount = user?.account;

        const tradeRef = doc(db, "trades_collection", position.id);
        const tradeSnap = await getDoc(tradeRef);

        if (!tradeSnap.exists()) {
            throw new Error("Trade not found.");
        }

        const tradeData = tradeSnap.data();
        if (tradeData.account !== currentAccount) {
            throw new Error("You are not authorized to delete this trade.");
        }

        // await deleteDoc(tradeRef);
        await updateDoc(tradeRef, {
            status: "completed",
            current_price: 0, // optional, ensures trigger
            closedBy: "manual",
            processed: false
        });

        setToastMessage("Position closed successfully.");
        setShowToast(true);
    } catch (error) {
        console.error("Failed to close position:", error.message);
        setToastMessage("Failed to close position.");
        setShowToast(true);
    }
};

export const removeAllPositionsForAccount = async (account) => {
    try {
        const tradesRef = collection(db, "trades_collection");
        const q = query(tradesRef, where("account", "==", account), where("status", "==", "active"));
        const snapshot = await getDocs(q);

        console.log('snapshot', snapshot);


        if (snapshot.empty) {
            console.log("No trades found for account:", account);
            return;
        }

        // const deletePromises = snapshot.docs.map((docSnap) =>
        //     deleteDoc(doc(db, "trades_collection", docSnap.id))
        // );
        const updatePromises = snapshot.docs.map((docSnap) =>
            updateDoc(doc(db, "trades_collection", docSnap.id), {
                status: "completed",
                current_price: 0, // optional, ensures trigger
                closedBy: "manual",
                processed: false
            })
        );

        await Promise.all(updatePromises);
        console.log(`Updated all trades for account: ${account}`);
    } catch (error) {
        console.error("Error updating all trades for account:", error);
    }
};



export const removePositionsBySymbol = async (symbol, account) => {
    try {
        const tradesRef = collection(db, "trades_collection");
        const q = query(tradesRef,
            where("account", "==", account),
            where("symbol", "==", symbol),
            where("status", "==", "active")

        );

        const snapshot = await getDocs(q);

        // const deletePromises = snapshot.docs.map((docSnap) =>
        //     deleteDoc(doc(db, "trades_collection", docSnap.id))
        // );

        const updatePromises = snapshot.docs.map((docSnap) =>
            updateDoc(doc(db, "trades_collection", docSnap.id), {
                status: "completed",
                current_price: 0, // optional, ensures trigger
                closedBy: "manual",
            })
        );

        await Promise.all(updatePromises);
        console.log(`Updated all positions with symbol: ${symbol}`);
    } catch (error) {
        console.error("Error updating positions by symbol:", error);
    }
};


export const removeSellPositionsBySymbol = async (symbol, account) => {
    try {
        const tradesRef = collection(db, "trades_collection");
        const q = query(tradesRef,
            where("account", "==", account),
            where("symbol", "==", symbol),
            where("status", "==", "active"),
            where("type", "==", "SELL") // Note: Ensure case matches stored value
        );

        const snapshot = await getDocs(q);

        // const deletePromises = snapshot.docs.map((docSnap) =>
        //     deleteDoc(doc(db, "trades_collection", docSnap.id))
        // );

        const updatePromises = snapshot.docs.map((docSnap) =>
            updateDoc(doc(db, "trades_collection", docSnap.id), {
                status: "completed",
                current_price: 0, // optional, ensures trigger
                closedBy: "manual",
            })
        );

        await Promise.all(updatePromises);
        console.log(`Updated all SELL positions with symbol: ${symbol}`);
    } catch (error) {
        console.error("Error updating SELL positions by symbol:", error);
    }
};